import React from 'react'; 
import SignaturePad from "react-signature-canvas";
import {Button} from '@progress/kendo-react-buttons';

const CusSignPad = (props) => {
    const {showViewBtn,sigPadRef} = props;
    return(
        <div>
            <div style={{padding:'5px',border:'1px dotted grey'}}>
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div>Sign here</div>
                    </div>
                </div>

                <div style={{width:"100%", height:"100%",backgroundColor: "cornsilk"}}>
                    <SignaturePad cancelable={false}
                        canvasProps={{
                        className: "setCanvasStyle",
                        }}
                        ref={sigPadRef} />
                </div>
     
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "1px",paddingTop:'10px'}}>
                        <button className="btn btn-back" onClick={props.onClickCear}>{'Clear'}</button>
                        <button className="k-button btn btn-success btn-float-right" onClick={props.onClickSave}>{'Save'}</button>
                    </div>
                </div>
            </div>
 
            {showViewBtn &&
            <div className="row around-xs inputPair elementVisible" style={{paddingTop:'15px'}}>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <Button look="outline"style={{whiteSpace:'break-spaces'}} className="btSize3" 
                        onClick={props.onClickView}>
                    <span className="k-file-group k-icon k-i-file-image"></span>View your signature
                    </Button>
                </div>
            </div>
            }
    </div>
    )
}

export default CusSignPad;